import { Boolean, Literal, Partial, Record, String, Union } from "runtypes";
import { CourseName } from "./course";
export const SectionName = CourseName.And(
  Record({
    CRN: String
  })
);
export const sectionNameToPath = (name) => `${name.year}/${name.semester}/${name.department}/${name.number}/${name.CRN}`;
export function ADGroupToSectionName(group) {
  const parts = group.split(",");
  if (parts.length === 0 || !parts[0].startsWith("CN=")) {
    return;
  }
  const courseParts = parts[0].replace("CN=", "").split(" ");
  if (courseParts.length !== 6) {
    return;
  }
  if (!courseParts[courseParts.length - 1].startsWith("CRN")) {
    return;
  }
  const [department, number, , yearString, semester, CRNprefixed] = courseParts;
  const year = parseInt(yearString);
  if (isNaN(year)) {
    return;
  }
  const CRN = CRNprefixed.replace("CRN", "");
  if (isNaN(parseInt(CRN))) {
    return;
  }
  return SectionName.check({ year, semester, department, number, CRN });
}
export function sectionNameToCourseName(section) {
  const { year, semester, department, number } = section;
  return CourseName.check({ year, semester, department, number });
}
export const SectionKind = Union(
  Literal("lecture"),
  Literal("lab"),
  Literal("online lecture"),
  Literal("online lab"),
  Literal("online discussion"),
  Literal("unknown")
);
export const Section = SectionName.And(
  Record({
    path: String,
    name: String,
    kind: SectionKind,
    lecture: Boolean,
    code: String,
    arranged: Boolean,
    online: Boolean
  }).And(
    Partial({
      days: String,
      startTime: String,
      endTime: String,
      building: String,
      room: String
    })
  )
);
//# sourceMappingURL=section.js.map
